/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 
import React, { useState, useEffect,useContext } from 'react';
import ThemeControls from '../Component/AllThemesControl';
import Element from './Element'
import {FormContext} from '../Component/Forms/FormContext'
import FormRenderer from '../Component/Forms/FormRenderer';
import { FormJSONCreateContext } from '../Component/FormJSONCreateContext';

function NestedRender(props) {
  const { useStyle} = ThemeControls;
  const classes = useStyle();
  const { handleChange } = useContext(FormContext);
  const { field_context,field_id,field_type,field_label } = props;
  const JsonContext = field_context;
  const { contextJson } = React.useContext(FormJSONCreateContext);
  const [masterJson, setMaterJson]=useState(JsonContext)
  const [update, setUpadte]=useState(false)
  console.log(contextJson)

  useEffect(()=>{
    Object.keys(contextJson).forEach((key,index) =>{
      if(key!=="xioFEConfig"){
        contextJson[key].fields.map((field)=>{
          if(field.field_type==="nestedRender"){
            // setMaterJson(field.field_context)
            setUpadte(pre=>!pre)
          }
        });
      }
    });
  },[field_label])

  let formType=''
  Object.keys(masterJson).map((key, index) => {
    if (key === "xioFEConfig") {
      formType=masterJson[key].TabStyle;
    }
    })
  const objData = Object.keys(masterJson).map((key, index) => {
    if(key !== "xioFEConfig"){
      //console.log(formType)
      return (       
          <div className={classes.breakForm}>
            {(masterJson[key].page_heading_label||masterJson[key].btn_name)&&<div className={classes.btnHeader}>
              {masterJson[key].page_heading_label?<h1>{masterJson[key].page_heading_label}</h1>:''}
              {masterJson[key].btn_name?<button className={classes.subBtn}>
                {masterJson[key].btn_name}
              </button>:null}
            </div>}
            <FormRenderer row={update} formJSON={masterJson[key]} formType={formType}/>
          </div>
      );
    } 
    return null;
  });

  return objData;
}

export default NestedRender;
